import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { IntergrationDtoKeyEnum } from '@zaoblako/shared/modules/integration/enums/intergration-dto-key.enum';
import { SecurityDtoKeysEnum } from '@zaoblako/shared/modules/security/enums/security-dto-keys.enum';
import { SaasDtoKeysEnum } from '@zaoblako/shared/modules/saas/enums/saas-dto-keys.enum';
import type { ProfileFindInterface } from '@zaoblako/shared/modules/security/dtos/profile/profile-find.dto';
import type { TelegramBotFindInterface } from '@zaoblako/shared/modules/integration/dtos/telegram-bot/telegram-bot-find.dto';
import type { FrmInstanceFindInterface } from '@zaoblako/shared/modules/saas/dtos/frm-instance/frm-instance-find.dto';

import * as yup from 'yup';

/** Telegram chat response body - DTO signature */
export interface TelegramChatInterface {
  /** Unique identifier (UUID). Cannot be changed. */
  id: string;

  // Tech columns
  /** Bot creation date and time */
  created: Date;
  /** Bot last update date and time */
  updated: Date;
  /** Bot soft delete date and time */
  deleted?: Date;

  // Data columns
  /** Chat display name */
  name: string;
  /** Unique chat ID in Telegram */
  telegramId: number;
  /** Related profile (for user chats) */
  profile?: ProfileFindInterface;
  /** Related instance (for group chats) */
  instance?: FrmInstanceFindInterface;
  /** Related bot */
  bot: TelegramBotFindInterface;
  /** Group chat flag. Calculated automatically in backend. */
  groupChat?: boolean;
}

/** Telegram chat response body - DTO schema */
export const TelegramChatDto = SerdeDtoClass.create<TelegramChatInterface>(IntergrationDtoKeyEnum.TELEGRAM_CHAT_DTO, {
  id: {
    label: 'Номер',
    serializer: yup.string(),
  },
  created: {
    sortable: true,
    label: 'Создан',
    serializer: yup.date(),
  },
  updated: {
    label: 'Изменен',
    serializer: yup.date(),
  },
  deleted: {
    optional: true,
    label: 'Удален',
    serializer: yup.date(),
  },
  name: {
    label: 'Имя группового чата или пользователя в Telegram',
    serializer: yup.string(),
  },
  telegramId: {
    label: 'Номер чата в Telegram',
    serializer: yup.number(),
  },
  profile: {
    optional: true,
    label: 'Профиль',
    hint: 'Определен только для пользовательских чатов',
    nested: SecurityDtoKeysEnum.PROFILE_FIND_DTO,
    serializer: (_, nested) => nested,
  },
  instance: {
    optional: true,
    label: 'Инстанс ФРМ',
    hint: 'Определен только для групповых чатов',
    nested: SaasDtoKeysEnum.FRM_INSTANCE_FIND_DTO,
    serializer: (_, nested) => nested,
  },
  bot: {
    label: 'Telegram-бот',
    nested: IntergrationDtoKeyEnum.TELEGRAM_BOT_FIND_DTO,
    serializer: (_, nested) => nested,
  },
});
